import React from 'react';
import { X, MapPin, Store } from 'lucide-react';
import { Retailer } from '../../../types/retailer';
import RetailerDetails from './RetailerDetails';

interface RetailerDetailViewProps {
  selected: number;
  retailers: Retailer[];
  onClose: () => void;
  isMobile: boolean;
}

const RetailerDetailView: React.FC<RetailerDetailViewProps> = ({
  selected,
  retailers,
  onClose,
  isMobile
}) => {
  if (selected === 0) return null;

  const selectedRetailer = retailers.find((retailer) => retailer.id === selected);
  if (!selectedRetailer) return null;

  return (
    <div className={`${isMobile ? 'fixed inset-0 z-50 bg-primary-blue-90 overflow-y-auto z-10' : 'border border-primary-blue-90 rounded-2xl'} text-white`}>
      <div className='flex flex-col bg-primary-blue-90 rounded-2xl items-center justify-center p-8 relative text-center'>
        <div className='w-full flex justify-end'>
          <X
            className='w-6 h-6 cursor-pointer'
            onClick={onClose}
          />
        </div>

        {/* Display logo if available, otherwise show store icon */}
        {selectedRetailer.logo_s3_url ? (
          <img
            src={selectedRetailer.logo_s3_url}
            alt={selectedRetailer.name}
            className='w-16 h-16 object-contain bg-white rounded-full p-2'
          />
        ) : (
          <div className='w-16 h-16 bg-primary-blue-80 rounded-full flex items-center justify-center'>
            <Store className='w-8 h-8 text-white' />
          </div>
        )}
        
        <div className='text-xl font-semibold mb-2 mt-4'>{selectedRetailer.name}</div>

        {selectedRetailer.address && (
          <div className='bg-primary-blue-80 flex items-center mt-2 rounded-2xl px-4 py-2'>
            <MapPin className='w-5 h-5 mr-2' />
            <p className='text-sm'>
              {selectedRetailer.address}
            </p>
          </div>
        )}
      </div>

      <RetailerDetails selectedRetailer={selectedRetailer} />
    </div>
  );
};

export default RetailerDetailView;
